/**
 * Konfiguracja zwrotów. Sklep kieruje do zewnętrznego serwisu „Wygodne zwroty"
 * — URL jest per-brand (lavmag → /lavmag, youlook → /youlook), a można go
 * nadpisać env NUXT_PUBLIC_RETURNS_URL. Wewnętrzna integracja /account/returns
 * jest domyślnie wyłączona na produkcji — sterowana runtime-flagą
 * NUXT_PUBLIC_INTERNAL_RETURNS_ENABLED (true włącza ją na dev/QA).
 *
 * `withdrawalUrl` to moduł odstąpienia od umowy (Dyrektywa UE 2023/2673) —
 * osobna ścieżka `/odstapienie` w tym samym serwisie; env
 * NUXT_PUBLIC_RETURNS_WITHDRAWAL_URL nadpisuje wartość z presetu brandu.
 * `widget` niesie hid integracji WZ (baner odstąpienia na /zwroty). Hid nadaje
 * WZ per konto sklepu i NIE ma go w presetach brandów — jedynym źródłem jest
 * konfiguracja deploymentu (inventory), jak dla GTM/Pixel/Segmentify:
 * NUXT_PUBLIC_RETURNS_WZ_BANNER_HID. Brak hidu = brak skryptu WZ, strona
 * /zwroty zostaje na własnym banerze (bezpieczny fallback, nic się nie psuje).
 *
 * Badge z logo WZ w stopce NIE jest używany — wystarcza tam tekstowy link
 * „Zwroty i odstąpienie od umowy" (decyzja 2026-07-31), więc widget hid z
 * instrukcji instalacji WZ jest nam niepotrzebny.
 *
 * Lokalnie włączysz baner, dopisując hid do `.env`.
 */
export function useReturns() {
  const config = useRuntimeConfig()
  const brand = useBrand()
  const externalUrl = (config.public.returnsUrl as string) || brand.returnsUrl
  const withdrawalUrl =
    (config.public.returnsWithdrawalUrl as string) ||
    brand.returnsWithdrawalUrl ||
    ''
  const internalEnabled = config.public.internalReturnsEnabled === true

  const bannerHid = (config.public.returnsWzBannerHid as string) || ''
  const widget = bannerHid ? { bannerHid } : undefined

  return {
    externalUrl,
    withdrawalUrl,
    internalEnabled,
    widget,
  }
}
